export default __webpack_public_path__ + "static/media/nutrition-icon.a4b13c6e.svg";